module.exports = __webpack_public_path__ + "static/img/mp_qrcode_jiandanke.a19d87d6.jpg";